import React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import useIsMobile from '../hooks/useIsMobile';
import { useThemeCustomStyles } from '../hooks/useThemeConfig';

function CheckBox({ control, handleChange }) {
  const small = useIsMobile();
  const styles = useThemeCustomStyles();
  const labelStyle = styles.InputLabel(small);
  const handleCheckBoxChange = (event) => {
  	 handleChange(event.target.checked);
  };
  return (
	<FormGroup>
	  <FormControlLabel control={<Checkbox iconStyle={{fill: 'white'}} sx={labelStyle}/>} sx={labelStyle} checked={control.data} label={control.title} onChange={handleCheckBoxChange} />
	</FormGroup>
  );
}

export default CheckBox;
